"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Links = Links;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactMintl = require("@godaddy/react-mintl");
var _link = _interopRequireDefault(require("@ux/link"));
var _enums = require("./enums");
function Links(props) {
  if (props.preset === 'internal-header') return null;
  const {
    eids
  } = props;
  const isType3 = props.privateLabelType === 3;
  const links = [(!isType3 || props.resellerUrls && props.resellerUrls.products) && /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "customer-link",
    key: "products",
    href: props.urls.products.href,
    "data-eid": eids.products
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: _enums.golf.products
  })), !isType3 && /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "customer-link",
    key: "renewals",
    href: props.urls.renewals.href,
    "data-eid": eids.renewals
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: _enums.golf.renewals
  })), (!isType3 || props.resellerUrls && props.resellerUrls.account) && /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "customer-link",
    key: "account",
    href: props.urls.account.href,
    "data-eid": eids.accountSettings
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: _enums.golf.accountSettings
  }))].filter(Boolean);
  if (props.privateLabelId === 1 && props.bottomLinks.length > 0) {
    links.push(/*#__PURE__*/_react.default.createElement("div", {
      className: "tray-menu-divider",
      key: "resourcesDivider"
    }));
    props.bottomLinks.forEach((link, i) => {
      if (link) {
        links.push(/*#__PURE__*/_react.default.createElement(_link.default, (0, _extends2.default)({}, link, {
          urlArgs: props.urlArgs,
          key: 'bottomLinks' + i,
          className: "customer-link bottom-link"
        })));
      }
    });
  }
  return links;
}
Links.propTypes = {
  eids: _propTypes.default.shape({
    products: _propTypes.default.string,
    renewals: _propTypes.default.string,
    accountSettings: _propTypes.default.string
  }),
  privateLabelType: _propTypes.default.number,
  privateLabelId: _propTypes.default.number,
  preset: _propTypes.default.string,
  resellerUrls: _propTypes.default.object,
  urls: _propTypes.default.object,
  urlArgs: _propTypes.default.object,
  bottomLinks: _propTypes.default.arrayOf(_propTypes.default.object)
};
var _default = exports.default = Links;